import { createSelector } from 'reselect';

const selectCustomer = state => state.customer;

export const makeSelectCustomers = () => {
  return createSelector(selectCustomer, globalState => globalState.customers);
};

export const makeSelectCustomer = () =>
  createSelector(selectCustomer, globalState => globalState.customer);

export const makeSelectCustomerVouchers = () =>
  createSelector(selectCustomer, globalState => globalState.vouchers);

export const makeSelectCustomerPendingRequests = () =>
  createSelector(selectCustomer, globalState => globalState.pendingRequests);

export const makeSelectCustomerGameTransactions = () =>
  createSelector(selectCustomer, globalState => globalState.gameTransactions);

export const makeSelectCustomerPendingGameTransactionRequests = () =>
  createSelector(selectCustomer, globalState => globalState.pendingGameTransactionsRequests);

export const makeSelectCustomerLoyaltyPrograms = () =>
  createSelector(selectCustomer, globalState => globalState.loyaltyPrograms);

export const makeSelectCustomerLoyaltyProgram = () =>
  createSelector(selectCustomer, globalState => globalState.loyaltyProgram);

export const makeSelectCustomerLoyaltyTransactions = () =>
  createSelector(selectCustomer, globalState => globalState.loyaltyTransactions);

export const makeSelectCustomerLoading = () =>
  createSelector(selectCustomer, globalState => globalState.loading);

export const makeSelectCustomerSearchString = () =>
  createSelector(selectCustomer, globalState => globalState.searchString);
